import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";
export const professionalService = {
  getSearchCriminalsTableInfoByDistrictId,
  getCriminalsAppInfoByUserSerach,
  getCriminalsAppInfoByDistrictSerach,
  getAllMaster,
  getCity,
  getDistrict,
  getDharm,
  getKayda,
  getKalam,
  getCrimeType,
  getCrimeTitle,
  getStatus,
  createCriminal,
  getCriminalsById,
  getCriminalsByIdView,
  updateCriminals,
  updateCriminalActiveStatus,
  getCriminalsTableInfoById,
  uploadImage,
  createNews,
  getNews,
  getAllNews,
  updateNews,
  getAboutCIMS,
  getGPSInformation,
  getReport3,
  getReport1,
  getReport4,
  getActiveAndNonActiveGpsInforByMasterId,
  markAsLockAddress,
  getTotalAppUsersCount,
  getTotalCriminalCount,
  getTotalRegisterPoliceStationCount,
  getTotalTodayGPSCount,
  getCCTVLocations,
  getAllCount,
  getDashboardCount,
  getCriminalsTableInfo,
  getCriminalsTableInfobyName,
  getCriminalsTableInfobyNameNew,
  getReportPoliceSpotvise,
  getReportAdminSpotvise,
  get2PlusReports,
  getPoliceStation2PlusReports,
  getSpot,
  createPreventiveAction,
  getPreventiveToolByID,
  updatePreventive,
  getPreventiveAction,
  get2PlusCriminalsViewsById,
  getCriminalsAppInfoByCitySerach,
  getExportCriminalByCityId,
  getUserCriminalsAppInfoBySerach,
  getGpsInformationWithFilter,
  getFilterCriminalsTableInfoByCityId,
  getFilterCriminalsTableInfoByUserId,
  getFilterByGunaCriminalsTableInfoByCityId,
  getFilterReport,
  searchOngoingReport,
  searchCompletedReport,
  getSearchPreventiveList,
  getOngoingSearchReport,
  getCompletedSearchReport,
  getPSCriminalsTableInfoByUserId,
  getFilterByGunaCriminalsTableInfoByDistrictId,
  getFilterSearchCriminalsTableInfoByCityId,
  getFilterSearchCriminalsTableInfoByUserId,
  getFilterCriminalsTableInfoByDistrictId,
  getFilterSearchCriminalsTableInfoByDistrictId,
  getSadyasthiti,
  createArrestAction,
  updateArrestAction,
  createNoticeInformation,
  updateNoticeInformation,
  getArrestInformationbyId,
  getArrestReport,
  getPreventiveList,
  getPreventiveCount,
  getPreventiveCountList,
  getOngoingPreventiveCountList,
  OngoingPreventiveActionListById,
  getCompletedPreventiveCountList,
  getActiveCities,
  getVerificationAllocation,
  getAppUsers,
  saveVerificationAllocation,
  AllocatedVerificationList,
  generateOtp,
  addVehicalDetailsThirdParty,
  addVehicalDetails,
  addDrivinglicenceThirdParty,
  addDrivinglicence,
  addAadharBasicThirdParty,
  addAadharBasic,
  addAadharotpThirdParty,
  addAadharotp,
  addPancomprehensiv,
  addPassportThirdParty,
  addPassport,
  addVoterThirdParty,
  addVoter,
  getVehicleDetails,
  getVoterDetails,
  getPassportDetails,
  getDrivingLicenseDetails,
  getAadharBasicDetails,
  getAadharOtpDetails,
  getPoliceStationWithGhatak,
  searchByGunhaCount,
  getOngoingPreventiveActionCount,
  getOngoingPreventiveActionList,
  getCompletedPreventiveActionCount,
  getCompletedPreventiveActionList,
  saveActs,
  saveSections,
  searchAddedKalam,
  getGPSCount,
  getPreventiveActionCount,
  get2PlusCount,
  getGunainfoSubHeadingByFilter,
  getGunhaInfoByFilter,
  getCriminalsNotFilledPoliceStationHeadingFilter,
  getGunaHeadingNotFilledPoliceStationArophiFilter,
  getCriminalsFilledPoliceStationHeadingFilter,
  getGunaHeadingFilledPoliceStationArophiFilter,
  filledPoliceStationDaily,
  notFilledPoliceStationDaily,
  totalappuserCount,
  totaltwoplusCount,
  preventionActionCount,
  surveillanceCount,
  getWanted,
  getWantedByDistrict,
  getGpsinformationPoliceStation,
  getNewPreventiveList,
  getNewPreventiveActionCount,
  getSearchNewPreventiveList,
  getCompletedPreventiveListById,
  getPreventiveListById,
  getNewPreventiveListById,
  CompletedPreventiveActionListById,
  getDistrictsid,
  languageSave,
  lanaguagesearch,
  getCrimeSubTitleByTitle,
  getGunaWiseYear,
  gunaYearWiseFilledAPI,
  gunaYearWiseNotFilledAPI,
  getTadipaarByCity,
  getTadipaarByPS,
  getTadipaarCountByCity,
  getWantedCountByCity,
  getPhotoStatusFilterByUserId,
  getPhotoStatusFilterByDistrict,
  getPhotoStatusFilterByCity,
  getNewCriminalsTableInfobydistrictName,
  postSearchHistory,
  getGunaReportPoliceSide,
  getBasicInformationByRegisterNumber,
  getGunareportByTitle,
  getCountGunaReportAdmin,
  getListGunaReportAdmin,
  getGunaTitleAdmin,
  noticeReport,
  getCrimeTitleByTitleId,
  getMainHead,
  AllocatedGagDetectionCityId,
  CreateModasoperandi,
  ListModasoperandi,
  CountModasoperandiHeadWise,
  ModasoperandiHeadId,
  getCountry,
  updateCountry,
  getStatesWiseCityData,
  getAllocatedImageProvisionByCity
};
//const baseUrl = 'http://localhost:8080/api';
// const baseUrl = "https://www.criminalmis.in/api";
//const baseUrl = 'https://www.criminalmis.in/api';
const baseUrl = config.apiGateway.baseUrl;
console.log("baseUrl", baseUrl);

function getAllMaster() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/getmaster`, requestOptions).then(
    handleResponse,
  );
}

// GET CITY
function getCity() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/city`, requestOptions).then(
    handleResponse,
  );
}

function getDistrict(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/professional/districts/${cityId}`,
    requestOptions,
  ).then(handleResponse);
}

function getDharm() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/dharm`, requestOptions).then(
    handleResponse,
  );
}

function getKayda() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/kayda`, requestOptions).then(
    handleResponse,
  );
}

function getKalam(actId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/kalam/${actId}`, requestOptions).then(
    handleResponse,
  );
}

function getCrimeType() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/crimetypes`, requestOptions).then(
    handleResponse,
  );
}

function getCrimeTitle() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/crimetitles`, requestOptions).then(
    handleResponse,
  );
}

function getStatus() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/professional/status`, requestOptions).then(
    handleResponse,
  );
}

function getSpot() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/professional/spot`, requestOptions).then(
    handleResponse,
  );
}

function getSadyasthiti() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/arrest/getSadyasthiti`, requestOptions).then(
    handleResponse,
  );
}

function createCriminal(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/create`, requestOptions).then(
    handleResponse,
  );
}

function createPreventiveAction(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createPreventiveTool`, requestOptions).then(
    handleResponse,
  );
}

function createArrestAction(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/arrest/create`, requestOptions).then(handleResponse);
}

function updateArrestAction(data, id) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/arrest/newupdate/${id}`, requestOptions).then(
    handleResponse,
  );
}
function createNoticeInformation(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/notice/create`, requestOptions).then(handleResponse);
}
function updateNoticeInformation(data, id) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/notice/newupdate/${id}`, requestOptions).then(
    handleResponse,
  );
}
function getArrestInformationbyId(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/arrest/getArrestInformationbyId/${id}`,
    requestOptions,
  );
}

function createNews(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/createnews`, requestOptions).then(
    handleResponse,
  );
}
function getNews(itemType, role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getNews/${role}/${itemType}/${cityId}`,
    requestOptions,
  ).then(handleResponse);
}
function getAllNews(itemType) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/getNews/${itemType}`, requestOptions).then(
    handleResponse,
  );
}
function getGPSInformation(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getGPSInformation/${cityId}`,
    requestOptions,
  );
}
function getGpsinformationPoliceStation(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getGpsinformationPoliceStation/${id}`,
    requestOptions,
  );
}

function getCCTVLocations(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/getCCTVLocation/${cityId}`, requestOptions);
}

function updateNews(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/updateNews/${id}`, requestOptions).then(
    handleResponse,
  );
}

function getAboutCIMS() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/getAboutUs`, requestOptions).then(
    handleResponse,
  );
}

function getCriminalsById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getcriminalbyid/${id}`,
    requestOptions,
  ).then(handleResponse);
}

function getCriminalsByIdView(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getcriminalbyidview/${id}`,
    requestOptions,
  ).then(handleResponse);
}

function getCriminalsTableInfoById(falg, id, control, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (falg === "cityId") {
    return fetch(
      `${baseUrl}/criminal/getCriminalsTableInfoByCityId/${page}/${size}/${id}`,
      requestOptions,
    );
  }
  if (falg === "districtId") {
    return fetch(
      `${baseUrl}/criminal/getCriminalsTableInfoByDistrictId/${page}/${size}/${id}`,
      requestOptions,
    );
  } else {
    return fetch(
      `${baseUrl}/criminal/getCriminalsTableInfoById/${page}/${size}/${id}`,
      requestOptions,
    );
  }
}

function getCriminalsTableInfo(falg, id, control) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsTableInfo/${id}`,
    requestOptions,
  );
}

function getCriminalsTableInfobyName(id, searchText) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsTableInfobyName/${id}/${searchText}`,
    requestOptions,
  );
}

function getCriminalsTableInfobyNameNew(values) {
  // http://localhost:8080/api/criminal/getNewCriminalsTableInfobyName/43/mangesh /0/10
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getNewCriminalsTableInfobyName`,
    requestOptions,
  );
}

function updateCriminals(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/update/${id}`, requestOptions).then(
    handleResponse,
  );
}

function updateCriminalActiveStatus(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/updateCriminalActiveStatus/${id}`,
    requestOptions,
  );
}

function get2PlusReports(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/get2PlusReports`, requestOptions);
}
function getPoliceStation2PlusReports(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getPoliceStation2PlusReports`,
    requestOptions,
  );
}
function getArrestReport(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/arrest/getArrestReport`, requestOptions);
}

function getReport3(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getReports3`, requestOptions);
}
function getReport1(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getReports1`, requestOptions);
}
function getReport4(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getReports4`, requestOptions);
}

function getReportAdminSpotvise(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/spotservellience/getReportAdminSpotvise`,
    requestOptions,
  );
}

function getReportPoliceSpotvise(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/spotservellience/getReportPoliceSpotvise`,
    requestOptions,
  );
}

function markAsLockAddress(data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/markAsLockAddress`, requestOptions);
}

function getTotalAppUsersCount(role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getTotalAppUsersCount/${role}/${cityId}`,
    requestOptions,
  );
}
function getTotalCriminalCount(role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getTotalCriminalCount/${role}/${cityId}`,
    requestOptions,
  );
}
function getTotalRegisterPoliceStationCount(role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getTotalRegisterPoliceStationCount/${role}/${cityId}`,
    requestOptions,
  );
}
function getTotalTodayGPSCount(role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getTotalTodayGPSCount/${role}/${cityId}`,
    requestOptions,
  );
}

function getAllCount(role, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getAllCounts/${role}/${cityId}`,
    requestOptions,
  );
}

function getDashboardCount(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getpoliceStationCounts/${cityId}`,
    requestOptions,
  );
}

function getActiveAndNonActiveGpsInforByMasterId(masterid) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getActiveAndNonActiveGpsInforByMasterId/${masterid}`,
    requestOptions,
  );
}

function uploadImage(data) {
  const formData = new FormData();
  data &&
    data.map((res) => {
      formData.append("profile_pic", res.originFileOb);
    });

  const requestOptions = {
    headers: {
      "content-type": "multipart/form-data",
      ...authHeader(),
    },
  };

  // return fetch(`${baseUrl}/criminal/uploadImages`, requestOptions).then(handleResponse);
  return axios
    .post(`${baseUrl}/criminal/uploadImages`, formData, requestOptions)
    .then((res) => {});
}

function getPreventiveToolByID(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/getPreventiveTool/${id}`, requestOptions);
}

function updatePreventive(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/preventive/update/${id}`, requestOptions).then(
    handleResponse,
  );
}

function getPreventiveAction() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/professional/preventive_action`, requestOptions);
}
function get2PlusCriminalsViewsById(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/get2pluscriminalbyid`, requestOptions).then(
    handleResponse,
  );
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  history.push("login");
}

function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // location.reload(true);
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function getCriminalsAppInfoByCitySerach(city, searchText, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsAppInfoByCitySerach/${city}/${searchText}/${page}/${size}`,
    requestOptions,
  );
}

function getUserCriminalsAppInfoBySerach(id, searchText, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getUserCriminalsAppInfoBySerach/${id}/${searchText}/${page}/${size}`,
    requestOptions,
  );
}

function getExportCriminalByCityId(city) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getExportCriminalByCityId/${city}/`,
    requestOptions,
  );
}

function getSearchCriminalsTableInfoByDistrictId(id, searchText, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getSearchCriminalsTableInfoByDistrictId/${id}/${searchText}/${page}/${size}`,
    requestOptions,
  );
}

function getCriminalsAppInfoByUserSerach(id, searchText, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsAppInfoByUserSerach/${id}/${searchText}/${page}/${size}`,
    requestOptions,
  );
}

function getCriminalsAppInfoByDistrictSerach(id, searchText, page, size) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsAppInfoByDistrictIdSerach/${id}/${searchText}/${page}/${size}`,
    requestOptions,
  );
}

function getGpsInformationWithFilter(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getGpsInformationWithFilter`,
    requestOptions,
  );
}

function getPreventiveList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getPreventiveList/`, requestOptions);
}

function getFilterCriminalsTableInfoByCityId(
  Id,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterCriminalsTableInfoByCityId/${Id}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterCriminalsTableInfoByUserId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterCriminalsTableInfoByUserId/${cityId}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterByGunaCriminalsTableInfoByCityId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterByGunaCriminalsTableInfoByCityId/${cityId}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterReport(
  startDate,
  endDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  const data = {
    startDate: startDate,
    endDate: endDate,
    cityId: Id,
    orderBy: orderBy,
    sortDirection: orderDirection,
    preventive_action: preventive_action,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getOrderByPreventiveList/`, requestOptions);
}

function searchOngoingReport(
  selectedDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  const data = {
    startDate: selectedDate,
    cityId: Id,
    orderBy: orderBy,
    sortDirection: orderDirection,
    preventive_action: preventive_action,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getOrderByOngoingPreventiveList/`,
    requestOptions,
  );
}

function searchCompletedReport(
  selectedDate,
  Id,
  orderBy,
  orderDirection,
  preventive_action,
) {
  const data = {
    startDate: selectedDate,
    cityId: Id,
    orderBy: orderBy,
    sortDirection: orderDirection,
    preventive_action: preventive_action,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getOrderByCompletedPreventiveList/`,
    requestOptions,
  );
}

function getPSCriminalsTableInfoByUserId(
  cityId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterByGunaCriminalsTableInfoByUserId/${cityId}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterByGunaCriminalsTableInfoByDistrictId(
  districtId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterByGunaCriminalsTableInfoByDistrictId/${districtId}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterSearchCriminalsTableInfoByCityId(
  cityId,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterSearchCriminalsTableInfoByCityId/${cityId}/${search}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getSearchPreventiveList(
  startDate,
  endDate,
  cityId,
  search,
  preventive_action,
) {
  const data = {
    startDate: startDate,
    endDate: endDate,
    cityId: cityId,
    search: search,
    preventive_action: preventive_action,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/getSearchPreventiveList/`, requestOptions);
}

function getOngoingSearchReport(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getSearchOngoingPreventiveList/`,
    requestOptions,
  );
}

function getCompletedSearchReport(
  startDate,
  cityId,
  search,
  preventive_action,
) {
  const data = {
    startDate: startDate,
    cityId: cityId,
    search: search,
    headings: preventive_action,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/getSearchCompletedPreventiveList/`,
    requestOptions,
  );
}

function getFilterSearchCriminalsTableInfoByUserId(
  id,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterSearchCriminalsTableInfoByUserId/${id}/${search}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterCriminalsTableInfoByDistrictId(
  districtId,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterCriminalsTableInfoByDistrictId/${districtId}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getFilterSearchCriminalsTableInfoByDistrictId(
  districtId,
  search,
  page,
  size,
  orderBy,
  orderDirection,
) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterSearchCriminalsTableInfoByDistrictId/${districtId}/${search}/${page}/${size}?orderBy=${orderBy}&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getPreventiveCount(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getPreventiveCount/`, requestOptions);
}

function getPreventiveCountList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/criminal/getPreventiveCountList/`, requestOptions);
}

function getOngoingPreventiveCountList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getOngoingPreventiveCountList/`,
    requestOptions,
  );
}

function OngoingPreventiveActionListById(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/OngoingPreventiveActionListById/`,
    requestOptions,
  );
}

function getCompletedPreventiveCountList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveCountList/`,
    requestOptions,
  );
}

function getActiveCities() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/verification/activeusers/`, requestOptions);
}
function AllocatedGagDetectionCityId(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/gang-detection/allocated-gang-detection/${cityId}/`,
    requestOptions,
  );
}

function getVerificationAllocation(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/allocated-verification/${cityId}`, requestOptions);
}

function getAllocatedImageProvisionByCity(cityId){
    const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/image-provision/city/${cityId}`, requestOptions);
}

function getAppUsers(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/appuser/present/${cityId}/`, requestOptions);
}

function saveVerificationAllocation(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/verification-module/`, requestOptions);
}

function AllocatedVerificationList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/allocated-verification-list/`, requestOptions);
}

function generateOtp(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/aadhaar-v2/generate-otp`,
    requestOptions,
  );
}

function addVehicalDetailsThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(`https://kyc-api.surepass.io/api/v1/rc/rc-full`, requestOptions);
}

function addVehicalDetails(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/vehicalDetails/`, requestOptions);
}

function addDrivinglicenceThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/driving-license/driving-license`,
    requestOptions,
  );
}

function addDrivinglicence(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/drivinglicence/`, requestOptions);
}

function addAadharBasicThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/aadhaar-validation/aadhaar-validation`,
    requestOptions,
  );
}

function addAadharBasic(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/aadharbasic/`, requestOptions);
}

function addAadharotpThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/aadhaar-v2/submit-otp`,
    requestOptions,
  );
}

function addAadharotp(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/aadharotp/`, requestOptions);
}

function addPancomprehensiv(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/pancomprehensiv/`, requestOptions);
}

function addPassportThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/passport/passport/passport-details`,
    requestOptions,
  );
}

function addPassport(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/passport/`, requestOptions);
}

function addVoterThirdParty(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcyOTUwNDUzMywianRpIjoiYjk3NTY5ZmMtNjA4Yy00M2Q0LWE5ZWUtM2I1N2JhNGIwZjY3IiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsIm5iZiI6MTcyOTUwNDUzMywiZXhwIjoyMzYwMjI0NTMzLCJlbWFpbCI6ImltYXJrdGVjaG5vbG9neUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.zcFPjeF2yQYYspMo37LHkeCK-uWI8KMS8giAOaafhLk",
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `https://kyc-api.surepass.io/api/v1/voter-id/voter-id`,
    requestOptions,
  );
}

function addVoter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/add/voter/`, requestOptions);
}

function getVehicleDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/vehicledetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getVoterDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/voterdetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getPassportDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/passportdetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getDrivingLicenseDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/drivinglicencedetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getAadharBasicDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/adhharbasicdetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getAadharOtpDetails(userId, page, size, orderDirection) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/adhharotpdetails/${userId}/${page}/${size}?&orderDirection=${orderDirection}`,
    requestOptions,
  );
}

function getPoliceStationWithGhatak(userId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/gunaFilterDropDown/${userId}/`,
    requestOptions,
  );
}

function searchByGunhaCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/gunaFilter/`, requestOptions);
}

function getOngoingPreventiveActionCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getOngoingPreventiveActionCount/`,
    requestOptions,
  );
}

function getOngoingPreventiveActionList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/OngoingPreventiveActionList/`,
    requestOptions,
  );
}

function getCompletedPreventiveActionCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveActionCount/`,
    requestOptions,
  );
}

function getCompletedPreventiveActionList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/CompletedPreventiveActionList/`,
    requestOptions,
  );
}

function saveActs(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/professional/add_acts/`, requestOptions);
}

function saveSections(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/professional/add_kalam/`, requestOptions);
}

function searchAddedKalam(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/professional/searchaddedkalam/`, requestOptions);
}

function getGPSCount(cityId, date) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/dailyGpsCount/${cityId}/${date}`,
    requestOptions,
  ).then(handleResponse);
}

function getPreventiveActionCount(cityId, date) {
  const formattedDate = date.replace("-", "/");
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/dailyPreventionActionCount/${cityId}/${formattedDate}`,
    requestOptions,
  ).then(handleResponse);
}

function get2PlusCount(cityId, date) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/daily2pluscount/${cityId}/${date}`,
    requestOptions,
  ).then(handleResponse);
}

function getGunainfoSubHeadingByFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getGunainfoSubHeadingByFilter/`,
    requestOptions,
  );
}

function getGunhaInfoByFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/getGunhaInfoByFilter/`, requestOptions);
}

function getCriminalsNotFilledPoliceStationHeadingFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getGunainfoSubHeadingNotFilledByFilter/`,
    requestOptions,
  );
}

function getGunaHeadingNotFilledPoliceStationArophiFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getGunaInfoNotFilledByFilter/`,
    requestOptions,
  );
}

function getCriminalsFilledPoliceStationHeadingFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getGunainfoSubHeadingFilledByFilter/`,
    requestOptions,
  );
}

function getGunaHeadingFilledPoliceStationArophiFilter(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getGunaInfoFilledByFilter/`,
    requestOptions,
  );
}

function filledPoliceStationDaily(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getTwoPlusAccusedByStationGraph/`,
    requestOptions,
  );
}

function notFilledPoliceStationDaily(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getTwoPlusCrimeAccusedByStationGraph/`,
    requestOptions,
  );
}

function totalappuserCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/totalappuserCount/`, requestOptions);
}

function totaltwoplusCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/totaltwoplusCount/`, requestOptions);
}

function preventionActionCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/preventionActionCount/`, requestOptions);
}

function surveillanceCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/surveillanceCount/`, requestOptions);
}

function getWanted(cityId, values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getConditionWanted/${cityId}`,
    requestOptions,
  );
}
function getWantedByDistrict(district, values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getConditionWantedByDistinct/${district}`,
    requestOptions,
  );
}
function getNewPreventiveList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/getNewPreventiveList`, requestOptions);
}

function getNewPreventiveActionCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getNewPreventiveActionCount`,
    requestOptions,
  );
}

function getSearchNewPreventiveList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getSearchNewPreventiveList`,
    requestOptions,
  );
}
function getCompletedPreventiveListById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveListById`,
    requestOptions,
  );
}

function getPreventiveListById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/getPreventiveListById`, requestOptions);
}

function getNewPreventiveListById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/getNewPreventiveListById`, requestOptions);
}
function CompletedPreventiveActionListById(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/CompletedPreventiveActionListById`,
    requestOptions,
  );
}
function getDistrictsid(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/getDistrictsid/${id}`, requestOptions).then(
    handleResponse,
  );
}

function languageSave(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/languageSave`, requestOptions);
}

function lanaguagesearch(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/lanaguagesearch/${id}`,
    requestOptions,
  ).then(handleResponse);
}

function getCrimeSubTitleByTitle(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/professional/getSubheadingByid/${id}`,
    requestOptions,
  ).then(handleResponse);
}
function getGunaWiseYear(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/gunaYearWiseAPI/`, requestOptions).then(
    handleResponse,
  );
}

function gunaYearWiseFilledAPI(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/gunaYearWiseFilledAPI/`,
    requestOptions,
  ).then(handleResponse);
}
function gunaYearWiseNotFilledAPI(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/gunaYearWiseNotFilledAPI/`,
    requestOptions,
  ).then(handleResponse);
}

function getTadipaarByCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getTadipaarCity`, requestOptions).then(
    handleResponse,
  );
}

function getTadipaarByPS(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getTadipaarByPS`, requestOptions).then(
    handleResponse,
  );
}
function getTadipaarCountByCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getTadipaarCountByCity`,
    requestOptions,
  ).then(handleResponse);
}
function getWantedCountByCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getWantedCountByCity`, requestOptions).then(
    handleResponse,
  );
}
function getPhotoStatusFilterByUserId(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPhotoStatusFilterByUserId`,
    requestOptions,
  ).then(handleResponse);
}
function getPhotoStatusFilterByDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPhotoStatusFilterByDistrict`,
    requestOptions,
  ).then(handleResponse);
}
function getPhotoStatusFilterByCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPhotoStatusFilterByCity`,
    requestOptions,
  ).then(handleResponse);
}
function getNewCriminalsTableInfobydistrictName(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getNewCriminalsTableInfobydistrictName`,
    requestOptions,
  ).then(handleResponse);
}
function postSearchHistory(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/searchHistory`, requestOptions).then(
    handleResponse,
  );
}
function getGunaReportPoliceSide(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getGunaReportPoliceSide`,
    requestOptions,
  ).then(handleResponse);
}
function getBasicInformationByRegisterNumber(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getBasicInformationByRegisterNumber`,
    requestOptions,
  ).then(handleResponse);
}
function getGunareportByTitle(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunareportByTitle`, requestOptions).then(
    handleResponse,
  );
}
function getCountGunaReportAdmin(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCountGunaReportAdmin`,
    requestOptions,
  ).then(handleResponse);
}
function getListGunaReportAdmin(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getListGunaReportAdmin`,
    requestOptions,
  ).then(handleResponse);
}
function getGunaTitleAdmin(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunaTitleAdmin`, requestOptions).then(
    handleResponse,
  );
}
function noticeReport(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeReport`, requestOptions).then(
    handleResponse,
  );
}
function getCrimeTitleByTitleId(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/professional/getCrimeTitleByTitleId/${id}`,
    requestOptions,
  ).then(handleResponse);
}
function getMainHead() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/professional/mainhead`, requestOptions).then(
    handleResponse,
  );
}
function CreateModasoperandi(values) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/createModasOperandi`, requestOptions).then(
    handleResponse,
  );
}
function ListModasoperandi() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/ListModasoperandi`, requestOptions).then(
    handleResponse,
  );
}
function CountModasoperandiHeadWise() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/CountModasoperandiHeadWise`,
    requestOptions,
  ).then(handleResponse);
}
function ModasoperandiHeadId(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/ModasoperandiHeadId/${id}`,
    requestOptions,
  ).then(handleResponse);
}
function getCountry() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/getCountry`, requestOptions).then(
    handleResponse,
  );
}
function updateCountry(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/updateCountry`, requestOptions).then(
    handleResponse,
  );
}
function getStatesWiseCityData(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/states-wise-city/${id}`,
    requestOptions,
  ).then(handleResponse);
}
